var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.988 2c7.726 0 13.989 5.876 13.989 13.988 0 8.112.023 0 .023 0v10.235a3.412 3.412 0 0 1-3.415 3.41 3.413 3.413 0 0 1-3.411-3.332v-.154c-.339 2.17-3.344 3.83-7.186 3.83C8.264 29.977 2 24.309 2 15.989 2 7.67 8.263 2 15.988 2zm-7.4 13.988a7.4 7.4 0 1 0 14.8 0 7.4 7.4 0 0 0-14.8 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAht);
export default __webpack_public_path__ + "static/media/AHT.e4ae06ba92bcf79bea891d74ac0e170a.svg";
export { ForwardRef as ReactComponent };